var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('vs-text',[_vm._v("Logging out...")]),(_setup.externalRequest === false && !_setup.isFetching)?_c('iframe',{staticClass:"d-none",attrs:{"sandbox":"allow-scripts allow-same-origin","src":_setup.adminPortalUrl},on:{"load":_setup.handleLogout}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }